import React from 'react'
import bgPages from '../../assets/background/404.png'

const NotFoundPage: React.FC = () => {
    return (
        <div className='w-screen h-screen'>
            <div
                className='w-full h-full animate-bounce duration-500 delay-700 flex justify-center items-center'>
                <img src={bgPages} alt="" />
            </div >
        </div>
    )
}

export default NotFoundPage